class Collapse {
  constructor(element, options = {}) {
    this.element = element;
    this.options = {
      duration: options.duration || 200,
      onShow: options.onShow || (() => {}),
      onHide: options.onHide || (() => {})
    };
    
    this.isTransitioning = false;
    this.isShown = false; // Always start as hidden
    
    // Store the original display value
    this.displayStyle = 'grid'; // Since we're using grid layout for the preview
    
    // Initial setup
    this.element.style.display = 'none';
    this.element.setAttribute('hidden', '');
  }

  toggle() {
    if (this.isShown) {
      this.hide();
    } else {
      this.show();
    }
  }

  show() {
    if (this.isShown || this.isTransitioning) return;
    
    this.isTransitioning = true;
    this.element.style.height = '0';
    this.element.style.opacity = '0';
    this.element.style.display = this.displayStyle;
    this.element.removeAttribute('hidden');
    
    // Force reflow
    this.element.offsetHeight;

    const height = this.element.scrollHeight;
    
    this.element.style.transition = `height ${this.options.duration}ms ease, opacity ${this.options.duration}ms ease`;
    this.element.style.height = `${height}px`;
    this.element.style.opacity = '1';

    setTimeout(() => {
      this.element.style.height = 'auto';
      this.element.style.transition = '';
      this.isTransitioning = false;
      this.isShown = true;
      this.options.onShow();
    }, this.options.duration);
  }

  hide() {
    if (!this.isShown || this.isTransitioning) return;
    
    this.isTransitioning = true;
    const height = this.element.scrollHeight;
    
    this.element.style.height = `${height}px`;
    // Force reflow
    this.element.offsetHeight;
    
    this.element.style.transition = `height ${this.options.duration}ms ease, opacity ${this.options.duration}ms ease`;
    this.element.style.height = '0';
    this.element.style.opacity = '0';

    setTimeout(() => {
      this.element.style.display = 'none';
      this.element.setAttribute('hidden', '');
      this.element.style.height = 'auto';
      this.element.style.transition = '';
      this.isTransitioning = false;
      this.isShown = false;
      this.options.onHide();
    }, this.options.duration);
  }
}

class HeaderSidebarProducts {
  constructor() {
    this.collapseInstances = new Map();
    this.init();
  }

  init() {
    // Initialize only product links
    const subLinks = document.querySelectorAll('.header-sidebar__linklist-button[data-product-link]');
    
    subLinks.forEach(subLink => {
      const linkContainer = subLink.closest('.header-sidebar__link-container');
      const preview = linkContainer.querySelector('.header-sidebar__link-preview');
      
      if (preview) {
        // Remove any existing hoto-show class to prevent conflicts
        preview.classList.remove('hoto-show');
        
        // Create collapse instance for each preview
        const collapse = new Collapse(preview, {
          duration: 200,
          onShow: () => {
            preview.classList.add('hoto-show');
            subLink.classList.add('hoto-active', 'hoto-hover');
          },
          onHide: () => {
            preview.classList.remove('hoto-show');
            subLink.classList.remove('hoto-active', 'hoto-hover');
          }
        });
        
        this.collapseInstances.set(subLink, collapse);

        subLink.addEventListener('click', (e) => {
          e.preventDefault();
          this.handleSubLinkClick(subLink);
        });
      }
    });

    // Show first product preview for each panel by default
    requestAnimationFrame(() => {
      document.querySelectorAll('.header-sidebar__sub-panel').forEach(panel => {
        const firstProductLink = panel.querySelector('.header-sidebar__linklist-button[data-product-link]');
        if (firstProductLink) {
          const collapse = this.collapseInstances.get(firstProductLink);
          if (collapse) {
            collapse.show();
          }
        }
      });
    });
  }

  handleSubLinkClick(clickedSubLink) {
    // Get the panel containing the clicked link
    const panel = clickedSubLink.closest('.header-sidebar__sub-panel');
    const clickedCollapse = this.collapseInstances.get(clickedSubLink);
    
    // If the clicked item is already shown, just hide it
    if (clickedCollapse && clickedCollapse.isShown) {
      clickedCollapse.hide();
      return;
    }
    
    // Hide all previews in the same panel
    panel.querySelectorAll('.header-sidebar__linklist-button[data-product-link]').forEach(subLink => {
      if (subLink !== clickedSubLink) {
        const collapse = this.collapseInstances.get(subLink);
        if (collapse) {
          collapse.hide();
        }
      }
    });

    // Show the clicked preview after a small delay to ensure smooth transition
    if (clickedCollapse) {
      requestAnimationFrame(() => {
        clickedCollapse.show();
      });
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new HeaderSidebarProducts();
}); 